import React from 'react';

export default ({
  customer,
  checked,
  onChange,
  paymentMethod,
  disabled
}) => {
  const {
    payment_config: {
      payment_methods: {
        [paymentMethod]: {
          convenience_fee: {
            confirmation_message
          }
        }
      }
    }
  } = customer;


  return <div className={'convenience-fee row'} onClick={onChange}>
    <div className={'col-lg-2 text-end convenience-fee-checkbox'}>
      <input type={'checkbox'} onChange={onChange} {...{checked}} disabled={disabled} />
    </div>
    <div className={'convenience-fee-notification col-lg-22'}>
      {confirmation_message}
    </div>
  </div>;
}
